import { render } from "./RFQ.vue?vue&type=template&id=efaab258&scoped=true"
import script from "./RFQ.vue?vue&type=script&lang=js"
export * from "./RFQ.vue?vue&type=script&lang=js"

import "./RFQ.vue?vue&type=style&index=0&id=efaab258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaab258"]])

export default __exports__